import { gql } from "@apollo/client";

export const GET_USER_PROMPTS = gql`
  query getUserPrompts {
    me {
      profile {
        prompts
      }
    }
  }
`;

export const ADD_UPS_USER_PROMPT = gql`
  mutation addUserPrompt($prompt: String!) {
    addUserPrompt(prompt: $prompt)
  }
`;
